import { baseApi } from 'lib/rtkQuery/baseApi';
import { QueryTags } from 'lib/rtkQuery/constants';
import { invalidatesTags } from 'lib/rtkQuery/helpers';
import qs from 'qs';
import {
  TDepartmentWithUsers,
  TGetDepartmentUserQueryParams,
  TGetWorkScheduleListQueryParams,
  TWorkScheduleListItem,
  TWorkScheduleSubmit,
} from './types';

const endpoint = `/work-schedules`;

export const workScheduleQueryApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [QueryTags.WorkSchedule],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getWorkScheduleList: builder.query<
        TWorkScheduleListItem[],
        TGetWorkScheduleListQueryParams
      >({
        query: params => {
          const queryParams = qs.stringify(params, {
            arrayFormat: 'repeat',
            encode: false,
          });
          return {
            url: `${endpoint}?${queryParams}`,
            method: 'GET',
          };
        },
        providesTags: [QueryTags.WorkSchedule],
      }),

      getDepartmentUserList: builder.query<
        TDepartmentWithUsers[],
        TGetDepartmentUserQueryParams
      >({
        query: params => {
          const queryParams = qs.stringify(params, {
            arrayFormat: 'repeat',
            encode: false,
          });
          return {
            url: `/departments/users?${queryParams}`,
            method: 'GET',
          };
        },
        providesTags: [QueryTags.WorkSchedule],
      }),

      getWorkScheduleDetail: builder.query<TWorkScheduleListItem, string>({
        query: workScheduleId => {
          return {
            url: `${endpoint}/${workScheduleId}`,
            method: 'GET',
          };
        },
        providesTags: [QueryTags.WorkSchedule],
      }),

      deleteWorkScheduleDetail: builder.mutation<void, string>({
        query: workId => {
          return {
            url: `${endpoint}/${workId}`,
            method: 'DELETE',
          };
        },
      }),

      createWorkSchedule: builder.mutation<void, TWorkScheduleSubmit>({
        query: (payload: TWorkScheduleSubmit) => {
          return {
            url: `${endpoint}`,
            method: 'POST',
            data: payload,
          };
        },
        invalidatesTags: invalidatesTags([QueryTags.WorkSchedule]),
      }),

      updateWorkSchedule: builder.mutation<
        void,
        { workScheduleId: string; payload: TWorkScheduleSubmit }
      >({
        query: ({ workScheduleId, payload }) => {
          return {
            url: `${endpoint}/${workScheduleId}`,
            method: 'PUT',
            data: payload,
          };
        },
        invalidatesTags: invalidatesTags([QueryTags.WorkSchedule]),
      }),

      uploadFile: builder.mutation<any, FormData>({
        query: formData => ({
          url: '/upload',
          method: 'POST',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }),
      }),
    }),
  });

export const {
  useGetWorkScheduleListQuery,
  useGetDepartmentUserListQuery,
  useCreateWorkScheduleMutation,
  useUploadFileMutation,
  useGetWorkScheduleDetailQuery,
  useDeleteWorkScheduleDetailMutation,
  useUpdateWorkScheduleMutation,
} = workScheduleQueryApi;
